import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import axios from 'axios';
import './newsletter-subscribe.component.scss';
var NewsletterSubscribe = /** @class */ (function (_super) {
    tslib_1.__extends(NewsletterSubscribe, _super);
    function NewsletterSubscribe(element) {
        return _super.call(this, element) || this;
    }
    NewsletterSubscribe.prototype.init = function () {
        this.containerForm = this.element.querySelector('.newsletter-subscribe__container-modal--form');
        this.containerLoader = this.element.querySelector('.newsletter-subscribe__container-modal--loader');
        this.containerSuccess = this.element.querySelector('.newsletter-subscribe__container-modal--success');
        this.form = this.element.querySelector('form.js-form-newsletter-subscribe');
        this.inputEmail = this.element.querySelector('.js-newsletter-subscribe-email');
        this.inputFirstName = this.element.querySelector('.js-newsletter-subscribe-firstname');
        this.inputSurname = this.element.querySelector('.js-newsletter-subscribe-surname');
        this.inputCheckboxes = Array.from(this.element.querySelectorAll('.js-newsletter-subscribe-checkbox'));
        this.btnSubmit = this.element.querySelector('.js-newsletter-subscribe-submit');
        this.modalSubscribed = this.element.querySelector('.js-already-subscribed');
        this.modalSubscribedClose = this.element.querySelector('.js-already-subscribed-close');
        this.modalSubscribedLabel = this.element.querySelector('.js-already-subscribed-label');
        this.modalSubscribedBtnAnotherEmail = this.element.querySelector('.js-already-subscribed-another-email');
        this.modalVerification = this.element.querySelector('.js-verification');
        this.modalVerificationClose = this.element.querySelector('.js-verification-close');
        this.modalVerificationLabel = this.element.querySelector('.js-verification-label');
        this.modalVerificationError = this.element.querySelector('.js-verification-error');
        this.modalVerificationContainerForm = this.element.querySelector('.js-verification-container-form');
        this.modalVerificationContainerLoader = this.element.querySelector('.js-verification-container-loader');
        this.modalVerificationBtnVerify = this.element.querySelector('.js-verification-button-verify');
        this.modalVerificationBtnResend = this.element.querySelector('.js-verification-button-resend');
        this.formOTP = this.element.querySelector('.js-verification-form');
        this.inputOTPOne = this.element.querySelector('.js-otp-1');
        this.inputOTPTwo = this.element.querySelector('.js-otp-2');
        this.inputOTPThree = this.element.querySelector('.js-otp-3');
        this.inputOTPFour = this.element.querySelector('.js-otp-4');
        this.inputOTPFive = this.element.querySelector('.js-otp-5');
        if (this.element.getAttribute("data-application-name")) {
            this.dataApplicationName = this.element.getAttribute("data-application-name");
        }
        else {
            this.dataApplicationName = "Application:CIB | Newsletter Subscription";
        }
        if (this.element.getAttribute("data-application-id")) {
            this.dataApplicationId = this.element.getAttribute("data-application-id");
        }
        else {
            this.dataApplicationId = "<ApplicationID>";
        }
        if (this.element.getAttribute("data-application-product")) {
            this.dataApplicationProduct = this.element.getAttribute("data-application-product");
        }
        else {
            this.dataApplicationProduct = "<ProductName>";
        }
        if (this.element.getAttribute("data-pagename")) {
            this.dataPageName = this.element.getAttribute("data-pagename");
        }
        else {
            this.dataPageName = "<PageName>";
        }
        this.sitename = newsLetterSiteName;
        this.checkHiddenCheckboxes();
    };
    NewsletterSubscribe.prototype.bindEvents = function () {
        var _this = this;
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	CHECK INTERACTION
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        this.form.addEventListener("input", function () {
            _this.analyticsFormStart();
        });
        this.formOTP.addEventListener("input", function () {
            _this.analyticsOTPFormStart();
        });
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	SUBSCRIBE BUTTON
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.btnSubmit) {
            this.btnSubmit.addEventListener('click', function (event) {
                event.preventDefault();
                var formFields = _this.form.querySelectorAll('input, select, checkbox');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.checkAlreadySubscribed();
                }
            });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	MODAL ALREADY SUBSCRIBED
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.modalSubscribedClose) {
            this.modalSubscribedClose.addEventListener('click', function (event) {
                _this.modalSubscribed.classList.add('modal--close');
                setTimeout(function () {
                    _this.modalSubscribed.classList.add('modal--closed');
                }, 250);
            });
        }
        if (this.modalSubscribedBtnAnotherEmail) {
            this.modalSubscribedBtnAnotherEmail.addEventListener('click', function (event) {
                _this.modalSubscribed.classList.add('modal--close');
                setTimeout(function () {
                    _this.modalSubscribed.classList.add('modal--closed');
                }, 250);
            });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	MODAL VERIFICATION
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.modalVerificationClose) {
            this.modalVerificationClose.addEventListener('click', function (event) {
                _this.modalVerification.classList.add('modal--close');
                setTimeout(function () {
                    _this.modalVerification.classList.add('modal--closed');
                }, 250);
            });
        }
        if (this.modalVerificationBtnVerify) {
            this.modalVerificationBtnVerify.addEventListener('click', function (event) {
                event.preventDefault();
                var formFields = _this.formOTP.querySelectorAll('input, select, checkbox');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.funcVerifyOTP();
                }
            });
        }
        if (this.modalVerificationBtnResend) {
            this.modalVerificationBtnResend.addEventListener('click', function (event) {
                _this.funcResendCode();
            });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	CHECKBOXES
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.inputCheckboxes) {
            this.inputCheckboxes.map(function (checkbox) { return checkbox.addEventListener('click', function (event) {
                // CHECK IF ALL IS CHECKED
                var element = event.target;
                if (element.value === 'all') {
                    if (element.checked) {
                        _this.inputCheckboxes.map(function (checkbox) {
                            if (checkbox.value === 'all') {
                            }
                            else {
                                checkbox.checked = true;
                            }
                        });
                    }
                    else {
                        _this.inputCheckboxes.map(function (checkbox) {
                            if (checkbox.value === 'all') {
                            }
                            else {
                                checkbox.checked = false;
                            }
                        });
                    }
                }
                else {
                    _this.inputCheckboxes.map(function (checkbox) {
                        if (checkbox.value === 'all') {
                            checkbox.checked = false;
                        }
                    });
                }
                // VALIDATION
                var valid = false;
                _this.inputCheckboxes.map(function (item) {
                    if (item.checked) {
                        valid = true;
                    }
                });
                if (valid) {
                    if (_this.btnSubmit) {
                        _this.btnSubmit.classList.remove('button--disabled');
                    }
                }
                else {
                    if (_this.btnSubmit) {
                        _this.btnSubmit.classList.add('button--disabled');
                    }
                }
            }); });
        }
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        ////	OTP
        ///////////////////////////////////////////
        ///////////////////////////////////////////
        if (this.inputOTPOne) {
            this.inputOTPOne.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowRight" || alpha.includes(keyCode)) {
                    _this.inputOTPTwo.focus();
                }
            });
            this.inputOTPOne.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPTwo) {
            this.inputOTPTwo.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowLeft" || alpha.includes(keyCode)) {
                    _this.inputOTPOne.focus();
                }
                else if (keyCode === "ArrowRight") {
                    _this.inputOTPThree.focus();
                }
            });
            this.inputOTPTwo.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPThree) {
            this.inputOTPThree.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowLeft" || alpha.includes(keyCode)) {
                    _this.inputOTPTwo.focus();
                }
                else if (keyCode === "ArrowRight") {
                    _this.inputOTPFour.focus();
                }
            });
            this.inputOTPThree.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPFour) {
            this.inputOTPFour.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                var alpha = '0123456789abcdefghijklmnopqrstuvwyzABCDEFGHIJKLMNOPQRSTUVWYZ';
                if (keyCode === "ArrowLeft" || alpha.includes(keyCode)) {
                    _this.inputOTPThree.focus();
                }
                else if (keyCode === "ArrowRight") {
                    _this.inputOTPFive.focus();
                }
            });
            this.inputOTPFour.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
        if (this.inputOTPFive) {
            this.inputOTPFive.addEventListener('keyup', function (event) {
                var keyCode = event.code;
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                if (keyCode === "ArrowLeft") {
                    _this.inputOTPFour.focus();
                }
            });
            this.inputOTPFive.addEventListener('focus', function (event) {
                var element = "";
                if (event.target) {
                    element = event.target;
                }
                element.value = "";
            });
        }
    };
    NewsletterSubscribe.prototype.checkAlreadySubscribed = function () {
        var _this = this;
        var containerForm = this.containerForm;
        var containerLoader = this.containerLoader;
        var modalVerificationLabel = this.modalVerificationLabel;
        var modalVerification = this.modalVerification;
        var modalSubscribedLabel = this.modalSubscribedLabel;
        var modalSubscribed = this.modalSubscribed;
        var inputEmail = this.inputEmail;
        var inputFirstName = this.inputFirstName;
        var inputSurname = this.inputSurname;
        var funcVerification = this.funcVerification;
        var funcAlreadySubscribed = this.funcAlreadySubscribed;
        var analyticsFormComplete = this.analyticsFormComplete;
        var analyticsSiteError = this.analyticsSiteError;
        var topics = "";
        containerForm.classList.add('d-none');
        containerLoader.classList.remove('d-none');
        var topicsDataLayer = "";
        this.selectedCheckboxes = [];
        this.inputCheckboxes.map(function (item) {
            if (item.checked) {
                if (item.value !== 'all') {
                    if (!_this.selectedCheckboxes.includes(item.value)) {
                        _this.selectedCheckboxes.push(item.value);
                    }
                }
            }
        });
        var arrayCheckboxesEmpty = [];
        var arrayCheckboxes = this.selectedCheckboxes;
        for (var index = 0; index < arrayCheckboxes.length; index++) {
            var topic = arrayCheckboxes[index];
            if (!arrayCheckboxesEmpty.includes(topic)) {
                if ((index + 1) === arrayCheckboxes.length) {
                    topics += topic;
                    topicsDataLayer += topic;
                    arrayCheckboxesEmpty.push(topic);
                }
                else {
                    topics += topic + ",";
                    topicsDataLayer += topic + ":";
                    arrayCheckboxesEmpty.push(topic);
                }
            }
        }
        // postdata
        var postData = 'action=SUBSCRIBE&';
        if (this.inputEmail) {
            postData += 'emailAddress=' + this.inputEmail.value + '&';
        }
        if (this.sitename) {
            postData += 'site=' + this.sitename + '&';
        }
        if (inputFirstName) {
            postData += 'name=' + inputFirstName.value + '&';
        }
        if (inputSurname) {
            postData += 'surname=' + inputSurname.value + '&';
        }
        if (topics) {
            postData += 'topics=' + topics + '&';
        }
        if (this.dataPageName) {
            postData += 'page=' + this.dataPageName + '&';
        }
        // variables
        var url = "/sbutils/sendEmailVerification";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            console.log(response.data);
            var result = response.data.result;
            if (result.includes('User sent')) {
                funcVerification(containerLoader, containerForm, modalVerificationLabel, modalVerification, inputEmail.value);
            }
            else {
                funcAlreadySubscribed(containerLoader, containerForm, modalSubscribedLabel, modalSubscribed, inputEmail.value);
            }
            analyticsFormComplete(topicsDataLayer);
        }).catch(function (response) {
            // service failed
            funcAlreadySubscribed(containerLoader, containerForm, modalSubscribedLabel, modalSubscribed, inputEmail.value);
            analyticsSiteError("500", "Service down", "OTP Send");
        });
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION ALREADY SUBSCRIBED
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterSubscribe.prototype.funcAlreadySubscribed = function (containerLoader, containerForm, modalLabel, modal, email) {
        // configured containers
        containerLoader.classList.add('d-none');
        containerForm.classList.remove('d-none');
        // show modal
        modalLabel.innerHTML = '<strong>' + email + '</strong>';
        modal.classList.remove('modal--close');
        modal.classList.remove('modal--closed');
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION CREATE OTP
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterSubscribe.prototype.funcVerification = function (containerLoader, containerForm, modalLabel, modal, email) {
        // configured containers
        containerLoader.classList.add('d-none');
        containerForm.classList.remove('d-none');
        // show modal
        modalLabel.innerHTML = '<strong>' + email + '</strong>';
        modal.classList.remove('modal--close');
        modal.classList.remove('modal--closed');
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION VERIFY OTP
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterSubscribe.prototype.funcVerifyOTP = function () {
        var _this = this;
        var containerForm = this.containerForm;
        var containerLoader = this.containerLoader;
        var containerSuccess = this.containerSuccess;
        var modalVerification = this.modalVerification;
        var modalVerificationError = this.modalVerificationError;
        var modalVerificationContainerForm = this.modalVerificationContainerForm;
        var modalVerificationContainerLoader = this.modalVerificationContainerLoader;
        modalVerificationContainerForm.classList.add('d-none');
        modalVerificationContainerLoader.classList.remove('d-none');
        var formOTP = this.formOTP;
        var OTP = "";
        OTP += this.inputOTPOne.value;
        OTP += this.inputOTPTwo.value;
        OTP += this.inputOTPThree.value;
        OTP += this.inputOTPFour.value;
        OTP += this.inputOTPFive.value;
        // analytics
        var analyticsOTPFormFail = this.analyticsOTPFormFail;
        var analyticsOTPFormComplete = this.analyticsOTPFormComplete;
        var analyticsApplicationCompleted = this.analyticsApplicationCompleted;
        var analyticsSiteError = this.analyticsSiteError;
        // checkboxes
        var operation = "subscribe";
        var inputFirstName = this.inputFirstName;
        var inputSurname = this.inputSurname;
        var inputEmail = this.inputEmail;
        var site = this.sitename;
        var contact = '';
        var formId = 'newsletter-subscribe';
        var topics = "";
        var topicsDataLayer = "";
        this.selectedCheckboxes = [];
        this.inputCheckboxes.map(function (item) {
            if (item.checked) {
                if (item.value !== 'all') {
                    if (!_this.selectedCheckboxes.includes(item.value)) {
                        _this.selectedCheckboxes.push(item.value);
                    }
                }
            }
        });
        var arrayCheckboxesEmpty = [];
        var arrayCheckboxes = this.selectedCheckboxes;
        for (var index = 0; index < arrayCheckboxes.length; index++) {
            var topic = arrayCheckboxes[index];
            if (!arrayCheckboxesEmpty.includes(topic)) {
                if ((index + 1) === arrayCheckboxes.length) {
                    topics += topic;
                    topicsDataLayer += topic;
                    arrayCheckboxesEmpty.push(topic);
                }
                else {
                    topics += topic + ",";
                    topicsDataLayer += topic + ":";
                    arrayCheckboxesEmpty.push(topic);
                }
            }
        }
        // postdata
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (inputFirstName) {
            postData += 'firstName=' + inputFirstName.value + '&';
        }
        if (inputSurname) {
            postData += 'surname=' + inputSurname.value + '&';
        }
        if (inputEmail) {
            postData += 'email=' + inputEmail.value + '&';
        }
        if (contact) {
            postData += 'contact=' + contact + '&';
        }
        if (topics) {
            postData += 'topics=' + topics + '&';
        }
        if (site) {
            postData += 'site=' + site + '&';
        }
        if (OTP) {
            postData += 'code=' + OTP + '&';
        }
        if (this.dataPageName) {
            postData += 'page=' + this.dataPageName + '&';
        }
        // variables
        var url = "/services/NewsLetterSubscription.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            var result = response.data.result;
            if (result.includes('New Subscriber') || result.includes('Existing Subscriber updated')) {
                modalVerification.classList.add('modal--close');
                setTimeout(function () {
                    modalVerification.classList.add('modal--closed');
                    containerForm.classList.add('d-none');
                    containerSuccess.classList.remove('d-none');
                    analyticsOTPFormComplete();
                }, 250);
                analyticsApplicationCompleted();
            }
            else {
                modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
                modalVerificationError.classList.remove('d-none');
                formOTP.reset();
                modalVerificationContainerLoader.classList.add('d-none');
                modalVerificationContainerForm.classList.remove('d-none');
                analyticsOTPFormFail();
            }
        }).catch(function (response) {
            // service failed
            modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
            modalVerificationError.classList.remove('d-none');
            formOTP.reset();
            modalVerificationContainerLoader.classList.add('d-none');
            modalVerificationContainerForm.classList.remove('d-none');
            analyticsOTPFormFail();
            analyticsSiteError("500", "Service down", "Verify OTP");
        });
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	FUNCTION RESEND CODE
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterSubscribe.prototype.funcResendCode = function () {
        var modalVerificationContainerForm = this.modalVerificationContainerForm;
        var modalVerificationContainerLoader = this.modalVerificationContainerLoader;
        var modalVerificationError = this.modalVerificationError;
        var formOTP = this.formOTP;
        var inputFirstName = this.inputFirstName;
        var inputSurname = this.inputSurname;
        modalVerificationContainerForm.classList.add('d-none');
        modalVerificationContainerLoader.classList.remove('d-none');
        // analytics
        this.analyticsOTPResend();
        var analyticsSiteError = this.analyticsSiteError;
        // postdata
        var postData = 'action=SUBSCRIBE&';
        if (this.inputEmail) {
            postData += 'emailAddress=' + this.inputEmail.value + '&';
        }
        if (this.sitename) {
            postData += 'site=' + this.sitename + '&';
        }
        if (inputFirstName) {
            postData += 'name=' + inputFirstName.value + '&';
        }
        if (inputSurname) {
            postData += 'surname=' + inputSurname.value + '&';
        }
        if (this.dataPageName) {
            postData += 'page=' + this.dataPageName + '&';
        }
        // variables
        var url = "/sbutils/sendEmailVerification";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            var result = response.data.result;
            if (result.includes('User sent')) {
                modalVerificationError.innerHTML = "<p>We have re-sent the code to your email address.</p>";
                modalVerificationError.classList.remove('d-none');
                formOTP.reset();
                modalVerificationContainerLoader.classList.add('d-none');
                modalVerificationContainerForm.classList.remove('d-none');
            }
            else {
                modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
                modalVerificationError.classList.remove('d-none');
                formOTP.reset();
                modalVerificationContainerLoader.classList.add('d-none');
                modalVerificationContainerForm.classList.remove('d-none');
            }
        }).catch(function (response) {
            modalVerificationError.innerHTML = "<p>The code is incorrect.<br>Please enter the correct code and try again.</p>";
            modalVerificationError.classList.remove('d-none');
            formOTP.reset();
            modalVerificationContainerLoader.classList.add('d-none');
            modalVerificationContainerForm.classList.remove('d-none');
            analyticsSiteError("500", "Service down", "Resend Code");
        });
    };
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    ////	analytics function
    ///////////////////////////////////////////
    ///////////////////////////////////////////
    NewsletterSubscribe.prototype.analyticsFormStart = function () {
        dataLayer.formStatus = false;
        dataLayer.application.applicationName = this.dataApplicationName;
        dataLayer.application.applicationID = this.dataApplicationId;
        dataLayer.application.applicationProduct = this.dataApplicationProduct;
        dataLayer.application.applicationStart = true;
        dataLayer.application.applicationStep = "step 1";
    };
    NewsletterSubscribe.prototype.analyticsFormComplete = function (options) {
        if (options === void 0) { options = ""; }
        dataLayer.formIsSubmitted = true;
        dataLayer.formStatus = "submitted";
        dataLayer.formOptions = options;
        _satellite.track('globalFormComplete');
        _satellite.track("globalVirtualPageView");
    };
    NewsletterSubscribe.prototype.analyticsOTPFormStart = function () {
        dataLayer.formStatus = '';
        dataLayer.formIsSubmitted = false;
    };
    NewsletterSubscribe.prototype.analyticsOTPFormFail = function () {
        dataLayer.otpStatus = "fail";
    };
    NewsletterSubscribe.prototype.analyticsOTPFormComplete = function () {
        dataLayer.otpStatus = "pass";
        dataLayer.formIsSubmitted = true;
        dataLayer.formStatus = "submitted";
        _satellite.track('globalFormComplete');
    };
    NewsletterSubscribe.prototype.analyticsOTPResend = function () {
        _satellite.track("otpResend");
    };
    NewsletterSubscribe.prototype.analyticsApplicationCompleted = function () {
        dataLayer.userRegistrationSuccess = true;
        dataLayer.application.applicationStart = false;
        dataLayer.application.applicationComplete = true;
        _satellite.track('globalApplicationComplete');
        _satellite.track("globalVirtualPageView");
    };
    NewsletterSubscribe.prototype.analyticsSiteError = function (code, reason, request) {
        dataLayer.siteErrorCode = code + " | " + reason + " | " + request;
        _satellite.track("sendSiteErrorCode");
    };
    NewsletterSubscribe.prototype.checkHiddenCheckboxes = function () {
        if (this.element.querySelector('.js-newsletter-subscribe-checkbox-group')) {
            var checkboxContainer = this.element.querySelector('.js-newsletter-subscribe-checkbox-group');
            var button = this.element.querySelector('.js-newsletter-subscribe-submit');
            if (checkboxContainer.classList.contains('hidden')) {
                button.classList.remove('button--disabled');
            }
        }
    };
    return NewsletterSubscribe;
}(Base));
export { NewsletterSubscribe };



//////////////////
// WEBPACK FOOTER
// ./components/newsletter-subscribe/newsletter-subscribe.component.ts
// module id = 569
// module chunks = 0